<template>
	<Modal
		:open="isOpen"
		:has-footer="false"
		:blocking="blocking"
		:force-backdrop-close="true"
		class="grid-context-menu"
		@close="$emit('close')"
	>
		<template #header>
			<slot name="header">
				<h2>{{ title }}</h2>
			</slot>
		</template>

		<template #body>
			<div class="grid-body">
				<div
					v-for="(item, idx) in menuItems"
					:key="idx"
					class="menu-item"
					@click="handleItemClick(item)"
				>
					<div class="menu-item--icon">
						<Icon
							v-if="item.icon"
							:icon-name="item.icon"
							size="lg"
						/>
					</div>
					<div
						v-if="item.label"
						class="menu-item--label"
					>
						{{ item.label }}
					</div>
				</div>
			</div>
		</template>
	</Modal>
</template>

<script>
import Modal from '../modal/Modal';
import ContextMenuMobileMixin from './ContextMenuMobileMixin';
export default {
	name:       'GridContextMenuMobile',
	components: { Modal },
	mixins:     [ContextMenuMobileMixin],
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/_fonts';

.grid-body {
	width: 100%;
	display: grid;
	grid-template-columns: auto auto auto;
	row-gap: 32px;
}

.menu-item {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.menu-item--icon {
	margin-bottom: 10px;
}

.menu-item--label {
	@include text-sm-2;
}

.grid-context-menu::v-deep {
	.modal--header {
		border-bottom: none;
		padding: 16px 16px 21px;
	}

	.modal--content {
		background-color: var(--color-grey-600);
		padding-bottom: 32px;
	}
}

</style>
